import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import BackVector from "../../Assets/Img/BackVector.svg";
import { useNavigate, useParams } from "react-router-dom";
import axiosMain from "../../http/axiosMain";
import { ProgressBar } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";

function InsightsDeliverables() {
  const navigate = useNavigate();

  const [influencerId, setInfluencerId] = useState(1);
  const [platform, setPlatform] = useState("instagram");
  const [deliverablesType, setDeliverablesType] = useState("");
  const [url, setUrl] = useState("");
  const [insights, setInsights] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const [influencerList, setInfluencerList] = useState([]);
  const [selectedInfluencer, setSelectedInfluencer] = useState("");

  const handleBackNavigation = () => {
    navigate(-1);
  };
  useEffect(() => {
    const fetchInfluencer = async () => {
      try {
        const response = await axiosMain.get("/api/influencer/influencers");

        // If the response is a single object, wrap it in an array
        const data = Array.isArray(response.data.influencers)
          ? response.data.influencers
          : [response.data.influencers];

        setInfluencerList(data);
      } catch (error) {
        console.error("Failed to fetch influencer:", error);
      }
    };

    fetchInfluencer();
  }, []);

  const handleGetInsights = async () => {
    setLoading(true);
    setError(null);

    const payload = {
      campaignId: 1532,
      influencerId: 1,
      platform,
      deliverablesType,
      url: "https://www.instagram.com/reel/DHFm8fOPPt1/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==",
    };

    try {
      const response = await axiosMain.post(
        "/api/campaign/get-insights",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setInsights(response.data.data);
    } catch (err) {
      console.error("Error fetching insights:", err);
      setError("Failed to fetch insights?. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const formatNumber = (num) => {
    if (typeof num !== "number") return "0";
    if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
    if (num >= 1000) return (num / 1000).toFixed(1) + "K";
    return num.toString();
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .toUpperCase();
  };
  return (
    <>
      <button onClick={handleBackNavigation} className="navback-button">
        <img src={BackVector} alt="back" className="back-vactor" />
        Back
      </button>
      <div className="insights  py-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="fw-bold m-0">Deliverables Insights For Glow Beyond</h4>
          <button className="btn btn-outline-success rounded">
            <i className="bi bi-plus-lg me-1"></i>
            Add Deliverables
          </button>
        </div>

        <div className="card border-0 shadow-sm p-5">
          <div className="card-header bg-light">Deliverables - 1</div>
          <div className="cardBody mt-2">
            <div className="row g-3 align-items-end">
              <div className="col-md-3">
                <label className="form-label">Select Influencer</label>
                <select
                  className="form-select"
                  value={selectedInfluencer}
                  onChange={(e) => setSelectedInfluencer(e.target.value)}
                >
                  <option value="">Select Influencer</option>
                  {influencerList.map((inf) => (
                    <option key={inf.user_id} value={inf.user_id}>
                      {inf.first_name} {inf.last_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label">Platform</label>
                <select
                  className="form-select"
                  value={platform}
                  onChange={(e) => setPlatform(e.target.value)}
                >
                  <option value="instagram">Instagram</option>
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label">Deliverables Type</label>
                <select
                  className="form-select"
                  value={deliverablesType}
                  onChange={(e) => setDeliverablesType(e.target.value)}
                >
                  <option value="">Select Deliverables</option>
                  <option value="reel">Reel</option>
                  <option value="story">Story</option>
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label">Links</label>
                <input
                  type="text"
                  className="form-control"
                  value={url}
                  placeholder="Enter Deliverables Link"
                  onChange={(e) => setUrl(e.target.value)}
                />
              </div>
              <div className="col-md-12 text-end mt-3">
                <button
                  className="btn btn-success px-4"
                  onClick={handleGetInsights}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Get Insights"}
                </button>
              </div>
            </div>

            {error && <div className="alert alert-danger mt-3">{error}</div>}
          </div>

          <div className="row g-2 my-3">
            <div className="col-xl-auto">
              <div className="insights-media">
                {insights?.url ? (
                  <video width="100%" height="100%" controls>
                    <source src={insights?.url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <img src={insights?.postImage} alt="Post" />
                )}
              </div>
              <div className="col-xl-9"></div>
            </div>
            <div className="col-xl-9">
              <div className="row">
                <div className="col-xl-6 col-md-12 mt-3">
                  <div className="insight-box">
                    <div className="insight-value">
                      {formatDate(insights?.postedAt)}
                    </div>
                    <div className="insight-label">Posting Date</div>
                  </div>
                </div>
                <div className="col-xl-6 col-md-12 mt-3">
                  <div className="insight-box">
                    <div className="insight-value">
                      {formatNumber(insights?.reach)}
                    </div>
                    <div className="insight-label">Reach</div>
                  </div>
                </div>
                <div className="col-xl-6 col-md-12 mt-3">
                  <div className="insight-box">
                    <div className="insight-value">{insights?.engagement}%</div>
                    <div className="insight-label">Engagement</div>
                  </div>
                </div>
                <div className="col-xl-6 col-md-12 mt-3">
                  <div className="insight-box">
                    <div className="insight-value">
                      {formatNumber(insights?.likes)}
                    </div>
                    <div className="insight-label">Likes</div>
                  </div>
                </div>
                <div className="col-xl-6 col-md-12 mt-3">
                  <div className="insight-box">
                    <div className="insight-value">
                      {formatNumber(insights?.comments)}
                    </div>
                    <div className="insight-label">Comments</div>
                  </div>
                </div>
                <div className="col-xl-6 col-md-12 mt-3">
                  <div className="insight-box">
                    <div className="insight-value">
                      {formatNumber(insights?.shares)}
                    </div>
                    <div className="insight-label">Shares</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="audience-grid">
            <div className="row">
              <div className="col-xl-6 mt-4">
                <div className="audience-card h-100">
                  <h5>Top Countries</h5>
                  {insights?.topCountries?.map((country, index) => (
                    <div key={index} className="audience-item">
                      <div className="LabelBox">
                        {country.label}{" "}
                        <span style={{ color: "#28a745", fontWeight: "500" }}>
                          {country.value.toFixed(2)}%
                        </span>
                      </div>
                      {/* Green Progress Bar */}
                      <div
                        className="progress"
                        style={{ height: "8px", backgroundColor: "#e9ecef" }}
                      >
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{
                            width: `${country.value}%`,
                            backgroundColor: "#28a745", // Bootstrap green
                          }}
                          aria-valuenow={country.value}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      {/* Green percentage text */}
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-xl-6 mt-4">
                <div className="audience-card h-100">
                  <h5>Top Cities</h5>
                  {insights?.topCities?.map((city, index) => (
                    <div key={index} className="audience-item">
                      <div className="LabelBox">
                        {city.label}{" "}
                        <span style={{ color: "#28a745", fontWeight: "500" }}>
                          {city.value.toFixed(2)}%
                        </span>
                      </div>

                      {/* Green Progress Bar */}
                      <div
                        className="progress"
                        style={{ height: "8px", backgroundColor: "#e9ecef" }}
                      >
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{
                            width: `${city.value}%`,
                            backgroundColor: "#28a745", // Bootstrap green
                          }}
                          aria-valuenow={city.value}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      {/* Green percentage text */}
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-xl-6 mt-4">
                <div className="audience-card h-100">
                  <h5>Age Group</h5>
                  {insights?.ageGroups?.map((age, index) => (
                    <div key={index} className="audience-item">
                      <div className="LabelBox">
                        {age.label}{" "}
                        <span style={{ color: "#28a745", fontWeight: "500" }}>
                          {age.value.toFixed(2)}%
                        </span>
                      </div>
                      {/* Green Progress Bar */}
                      <div
                        className="progress"
                        style={{ height: "8px", backgroundColor: "#e9ecef" }}
                      >
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{
                            width: `${age.value}%`,
                            backgroundColor: "#28a745", // Bootstrap green
                          }}
                          aria-valuenow={age.value}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      {/* Green percentage text */}
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-xl-6 mt-4">
                <div className="audience-card">
                  <h5>Audience Gender</h5>

                  {/* Donut Chart */}
                  <div style={{ width: "200px", margin: "0 auto" }}>
                    <Doughnut
                      data={{
                        labels: insights?.audiences?.map((aud) => aud.label),
                        datasets: [
                          {
                            data: insights?.audiences?.map((aud) => aud.value),
                            backgroundColor: ["#6b8e76", "#6b8e7694"], // Green for Male, Purple for Female
                            borderWidth: 0,
                          },
                        ],
                      }}
                      options={{
                        plugins: {
                          legend: {
                            display: false, // Hide default legend
                          },
                        },
                        cutout: "70%",
                      }}
                    />
                  </div>

                  {/* Centered Text Inside Donut (Male Percentage) */}
                  <div className="donut-center-text">
                    <span style={{ color: "#28a745", fontWeight: "600" }}>
                      {insights?.audiences[0]?.value.toFixed(2)}%
                    </span>
                    <p>Male Audience</p>
                  </div>

                  {/* Gender Breakdown */}
                  <div className="gender-list">
                    {insights?.audiences?.map((aud, index) => (
                      <div key={index} className="gender-row">
                        <span
                          className="dot"
                          style={{
                            backgroundColor:
                              aud.label === "Male" ? "#6b8e76 " : "#6b8e76 ",
                          }}
                        ></span>
                        {aud.label} -{" "}
                        <strong
                          style={{
                            color:
                              aud.label === "Male" ? "#6b8e76 " : "#6b8e76 ",
                          }}
                        >
                          {aud.value.toFixed(2)}%
                        </strong>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InsightsDeliverables;